<template>
  <div class="wrapper resource-container">
    <div class="resource-header">
      <div class="resource-titile text-overflow-ellipsis-2">
        {{ title }}
      </div>
      <div class="resource-desc text-overflow-ellipsis-2">
        {{ description }}
      </div>
    </div>
    <div :class="{ 'expanse-content': resourceType === 'single' }">
      <ResourceWraper
        :show-more="showMore"
        :data-list="showMore ? dataList.slice(0, showMoreNum) : dataList"
        :resource-type="resourceType"
        @download="handleDownload"
        @play="handlePlay"
      />
    </div>
    <div
      v-if="isShowMore"
      class="expanse-container"
      :style="{ height: expanseHeight }"
    >
      <div
        ref="expanseContainer"
        :class="{ 'expanse-content': resourceType === 'single' }"
      >
        <ResourceWraper
          :show-more="showMore"
          :data-list="dataList.slice(showMoreNum)"
          :resource-type="resourceType"
          @download="handleDownload"
          @play="handlePlay"
        />
      </div>
    </div>
    <div v-if="isShowMore" class="expanse-bottom">
      <div class="bottom-more" @click="handleExpanse">
        <div
          class="iconfont icon-double-arrow-top"
          :class="{ 'icon-reverse': !isExpanse }"
        />
        <span class="expanse-text">{{
          isExpanse ? langContext.retract : langContext.more
        }}</span>
      </div>
    </div>
    <VideoPopup ref="videoPopup" />
  </div>
</template>

<script>
import mixin from './mixin';
import trackReportMixin from '../Common/CommonMixin/trackReport';
import bus from 'common/bus';
import { s3Download } from 'common/utils.js';
import ResourceWraper from './ResourceWraper/web';
import VideoPopup from 'components/common/VideoPopup/index';

export default {
  components: {
    ResourceWraper,
    VideoPopup,
  },
  mixins: [mixin, trackReportMixin],
  data() {
    return {
      hasEmittedLoaded: false,
    };
  },
  computed: {
    // 双资料样式单行占位较大,首屏只展示5个,超出走 view more;其余样式沿用端默认阈值
    showMoreNum() {
      return this.resourceType === 'double' ? 5 : 8;
    },
  },
  watch: {
    // 当异步数据返回后触发，向父层透传完成事件
    dataList(newVal) {
      if (!this.hasEmittedLoaded && Array.isArray(newVal) && newVal.length > 0) {
        this.hasEmittedLoaded = true;
        this.$emit('components-loaded');
      }
    },
  },
  mounted() {
    // 若 dataList 初始即已就绪，尽快告知父级以便继续渲染后续组件，降低 CLS
    if (!this.hasEmittedLoaded && Array.isArray(this.dataList) && this.dataList.length > 0) {
      this.hasEmittedLoaded = true;
      this.$emit('components-loaded');
    }
  },
  methods: {
    // 展示所有筛选项
    handleExpanse() {
      const marginHeight = this.resourceType === 'double' ? 40 : 0;
      this.expanseHeight = this.isExpanse
        ? 0
        : `${this.$refs.expanseContainer.offsetHeight + marginHeight}px`;
      this.isExpanse = !this.isExpanse;
    },
    async handleDownload({ id, name }) {
      this.buttonTrackReport({ buttonName: name });
      const materialsClickNum = window.localStorage.getItem('materialsClickNum') || 0;
      window.localStorage.setItem(
        'materialsClickNum',
        Number(materialsClickNum) + 1,
      );

      if (this.supportNeedLogin) {
        // 支持 needLogin 的分校：完全由 needLogin 控制
        if (this.needLogin !== false && !this.isLogin) {
          bus.$emit('login', { triggerSource: 'down' });
          return;
        }
      } else {
        // 其他分校：保持原有 allowMaterialsNum 逻辑
        if (!this.isLogin && Number(materialsClickNum) >= this.allowMaterialsNum) {
          bus.$emit('login', { triggerSource: 'down' });
          return;
        }
      }

      const resData = await this.getResourceData(id);
      if (!resData) return;
      // 后端兜底：100007 错误码处理
      if (resData._needLogin) {
        bus.$emit('login', { triggerSource: 'down' });
        return;
      }
      s3Download(resData.signedUrl);
      // gtm 资料组件下载埋点
      window.dataLayer.push({
        event: 'download_resources_gtm',
      });
    },
    async handlePlay({ id, name }) {
      this.buttonTrackReport({ buttonName: name });
      const materialsClickNum = window.localStorage.getItem('materialsClickNum') || 0;
      window.localStorage.setItem(
        'materialsClickNum',
        Number(materialsClickNum) + 1,
      );

      if (this.supportNeedLogin) {
        if (this.needLogin !== false && !this.isLogin) {
          bus.$emit('login', { triggerSource: 'down' });
          return;
        }
      } else {
        if (!this.isLogin && Number(materialsClickNum) >= this.allowMaterialsNum) {
          bus.$emit('login', { triggerSource: 'down' });
          return;
        }
      }

      const resData = await this.getResourceData(id);
      if (!resData) return;
      if (resData._needLogin) {
        bus.$emit('login', { triggerSource: 'down' });
        return;
      }
      this.$refs.videoPopup.handleOpen(resData.signedUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.resource-container {
  padding: 40px 40px 32px;
  border-radius: 16px;
  border: 1px solid #ebebeb;
  background: #fff url("./assets/imgs/web_bg.png") no-repeat;
  background-size: 142px 199px;
  background-position: 100% 0%;

  .resource-header {
    color: var(--txt-color-link);
    padding-right: 214px;

    .resource-titile {
      margin-bottom: 10px;
      font-size: 24px;
      font-weight: bold;
      line-height: 32px;
    }

    .resource-desc {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
  }

  .expanse-content {
    /deep/.resource-wraper-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .resource-content {
        width: calc((100% - 20px) / 2);
      }
    }
  }

  .expanse-container {
    height: 0;
    overflow: hidden;
    transition: height 0.4s;
  }

  .expanse-bottom {
    display: flex;
    justify-content: center;
    padding-top: 30px;

    .bottom-more {
      display: flex;
      align-items: center;
      color: rgba(0, 0, 0, 0.6);
      cursor: pointer;

      .icon-double-arrow-top {
        padding-top: 3px;
        font-size: 14px;
        transform: scale(0.7);
      }

      .icon-reverse {
        transform: rotate(180deg) scale(0.7);
      }

      .expanse-text {
        margin-left: 10px;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
      }

      &:hover {
        color: var(--txt-color-link);
      }
    }
  }
}
</style>
